import {SmallGreyButton} from "../../../../misc/SmallGreyButton";
import FindReplaceIcon from '@mui/icons-material/FindReplace';
import {useContext, useState} from "react";
import {TransferProductModal} from "./TransferProductModal";
import {ChangePreviewContext} from "../../shopdrawing/ShopDrawingChangePreview";

export function TransferProducts(props: {
    div10?: boolean;
}) {
    const [show, setShow] = useState(false);
    const ctx = useContext(ChangePreviewContext);
    if(ctx.enabled) return null;

    return (<>
        <SmallGreyButton startIcon={<FindReplaceIcon />} onClick={() => setShow(true)}>Edit by Product</SmallGreyButton>
        {show && <TransferProductModal div10={props.div10} onDone={() => setShow(false)} />}
    </>)
}